import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Accordion, useAccordionButton } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import SubMenuCandidateSelection from '../../components/menus/SubMenuCandidateSelection'
import { getActiveSelectionsByCandidate, getFinishedSelectionsByCandidate } from '../../actions/selectionsActions'
import { getCourseSubjects, getLevels } from '../../actions/miscellaneousActions'
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { changeCandidateStatus } from '../../actions/choosesActions'
import SelectionStatus from '../../components/selection/selectionStatus'

export default function CompletedProcesses() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {loading, selections} = useSelector(state => state.selections)
    const {levels, subjects} = useSelector(state => state.miscellaneous)
    const {result} = useSelector(state => state.chooses)

    const [selectedSelection, setSelectedSelection] = useState(null)

    const capitalizeFirstCharacter = (string) => {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        } else {
            return ''
        }
    }

    const handleAcceptSelection = (selection) =>  {
        setSelectedSelection(selection)
        Swal.fire({
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: true,
            text: t('selection.candidateAcceptQuestion'),
            cancelButtonText: t('global.cancel'),
            confirmButtonText: t('global.yes')
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(changeCandidateStatus(selection?.choose?._id, 1))
            }
        })
    }

    const handleRejectSelection = (selection) =>  {
        setSelectedSelection(selection)
        Swal.fire({
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: true,
            text: t('selection.candidateRejectQuestion'),
            cancelButtonText: t('global.cancel'),
            confirmButtonText: t('global.yes')
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(changeCandidateStatus(selection?.choose?._id, 2))
            }
        })
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(client){
            dispatch(getFinishedSelectionsByCandidate(client?.id))
            dispatch(getLevels())
            dispatch(getCourseSubjects())
        }
    },[dispatch, t, client])

    useEffect(() => {
        if (result) {
            const selectedSelectionCopy = {...selectedSelection}
            setSelectedSelection(null)
            Swal.fire({
                showConfirmButton: true,
                showDenyButton: false,
                confirmButtonText: t('global.great'),
                icon: 'success',
                text: t('selection.' + result)
            })
            if (result === "1candidateStatusSuccess") {
                navigate("/candidate/process/" + selectedSelectionCopy?._id)
            } else {
                dispatch(getActiveSelectionsByCandidate(client?.id))
            }
        }
    }, [result, dispatch, client, navigate])

    return (
        <>
            <Container className='cuerpo'>
                <Row className='mb-5'>
                    <Col className='d-flex align-items-center'>
                        <img src="/images/config.svg" alt="Procesos" />
                        <h1 className='ms-2 m-0'>{t('menus.candidateProcesses')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5'>
                                <Row className='mb-5'>
                                    <Col>
                                        <h3>{t('menus.completedprocesses')}</h3>
                                    </Col>
                                </Row>
                                <SubMenuCandidateSelection section="completedProcesses"/>
                                {
                                    loading
                                    ?
                                        <div className='d-flex justify-content-center'>
                                            <span className="indicator-label">
                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                        </div>
                                    :
                                        selections?.length > 0
                                        ?
                                        <>
                                            <Row className="mt-3 border-bottom">
                                                <Col xs={5} className='fw-bold py-2'>{t("selection.title")}</Col>
                                                <Col xs={2} className='fw-bold py-2'>{t("selection.specialty")}</Col>
                                                <Col xs={2} className='fw-bold py-2'>{t("selection.subject")}</Col>
                                                <Col xs={2} className='fw-bold py-2'>{t("selection.school")}</Col>
                                                <Col xs={1} className='fw-bold py-2 bg-grey'>{t("global.actions")}</Col>
                                            </Row>
                                            <Accordion>
                                                {selections?.map((selection, selectionIndex) => (
                                                    <Card key={selectionIndex}>
                                                        <Card.Header>
                                                            <Row className='w-100 me-2'>
                                                                <Col xs={5} className='fw-bold py-2'><AccordionToggle eventKey={selectionIndex}>{selection.title}</AccordionToggle></Col>
                                                                <Col xs={2} className='fw-bold py-2'>{capitalizeFirstCharacter(levels?.find(l => l.id === selection.specialty)?.label)}</Col>
                                                                <Col xs={2} className='fw-bold py-2'>{t("subjects." + subjects?.find(s => s.id === selection.subject)?.label)}</Col>
                                                                <Col xs={2} className='fw-bold py-2'>{selection.school.name}</Col>
                                                                <Col xs={1} className='fw-bold py-2 text-center'>
                                                                    {
                                                                        !selection.choose?.candidateStatus &&
                                                                        <>
                                                                            <i className='fas fa-check cursor me-1' onClick={() => handleAcceptSelection(selection)}/>
                                                                            <i className='fas fa-x cursor mx-1' onClick={() => handleRejectSelection(selection)}/>
                                                                        </>
                                                                    }
                                                                    <Link to={`/candidate/process/${selection._id}`} className={`${!selection.choose?.candidateStatus ? 'ms-1' : ''}`}><img src='/images/eye.svg' alt='Ver'/></Link>
                                                                </Col>
                                                            </Row>
                                                        </Card.Header>
                                                        <Accordion.Collapse eventKey={selectionIndex}>
                                                            <Card.Body>
                                                                <div>
                                                                    <h5 className='fw-bold'>{t("selection.status")}</h5>
                                                                    {
                                                                        selection.choose &&
                                                                        <SelectionStatus choose={selection.choose} selection={selection}/>
                                                                    }
                                                                </div>
                                                                <div>
                                                                    <h5 className='fw-bold'>{t("selection.offerSummary")}</h5>
                                                                    <Row className='bg-grey'>
                                                                        <Col xs={6} className='py-2 pe-5'>
                                                                            <div className='d-flex justify-content-between'>
                                                                                {t("users.province")}
                                                                                <small>{provinces?.find(p => p.value === selection.school.province)?.label}</small>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={6} className='py-2 ps-5'>
                                                                            <div className='d-flex justify-content-between'>
                                                                                {t("selection.contractType")}
                                                                                <small>
                                                                                    {
                                                                                        selection?.fixedDiscontinuous
                                                                                        ?
                                                                                            t('selection.fixedDiscontinuous')
                                                                                        :
                                                                                            t('profile.candidate.'+selection?.contractType)
                                                                                    }
                                                                                </small>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col xs={6} className='py-2 pe-5'>
                                                                            <div className='d-flex justify-content-between'>
                                                                                {t("users.town")}
                                                                                <small>{towns?.find(p => p.value === selection.school.town)?.label}</small>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={6} className='py-2 ps-5'>
                                                                            <div className='d-flex justify-content-between'>
                                                                                {t("profile.candidate.idealPosition.workDay.label")}
                                                                                <small>{t("profile.candidate.idealPosition.workDay." + selection.workdayType)}</small>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className='bg-grey'>
                                                                        <Col xs={6} className='py-2 pe-5'>
                                                                            <div className='d-flex justify-content-between'>
                                                                                {t("selection.shortIncorporationDate")}
                                                                                <small>{`${String(new Date(selection.incorporationDate).getDate()).padStart(2, '0')}/${String(new Date(selection.incorporationDate).getMonth() + 1).padStart(2, '0')}/${new Date(selection.incorporationDate).getFullYear()}`}</small>
                                                                            </div>
                                                                        </Col>
                                                                        {
                                                                            selection.distance !== null &&
                                                                            <Col xs={12} md={6} className='d-flex justify-content-between'>
                                                                                <div className='title'>{t("selection.distance")}</div>
                                                                                <div className='data'>{selection.distance !== 0 && selection.distance !== "0" ? `${Math.trunc(Number(selection.distance))} km` : t("selection.zeroDistance")}</div>
                                                                            </Col>
                                                                        }
                                                                    </Row>
                                                                </div>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                ))}
                                            </Accordion>
                                        </>
                                        :
                                        <div className='text-center'>{t("selection.thereisnotprocess")}</div>

                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

function AccordionToggle({children, eventKey, callback}) {
    const handleAccordionToggle = useAccordionButton(
        eventKey,
        () => callback && callback(eventKey),
    )

    return (
        <span onClick={handleAccordionToggle} className='cursor'>{children}</span>
    )
}